module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("3")])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-257"
    }
  }, [_vm._v("Crude Oil Characteristics")])])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-257"
    }
  }, [_c('i', [_vm._v("Let these describe the indescribable.")])])]), _c('p', {
    staticClass: "auteur"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-257"
    }
  }, [_c('i', [_vm._v("Childe Harold’s Pilgrimage")]), _vm._v(" —Lord Byron")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-257"
    }
  }, [_c('span', {
    staticClass: "let"
  }, [_c('b', [_vm._v("W")])]), _vm._v("hat "), _c('i', [_vm._v("is")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-258"
    }
  }, [_vm._v("crude oil anyway? The best way to describe it is to start by saying what it is not and how it doesn’t behave. It is not "), _c('i', [_vm._v("a")]), _vm._v(" chemical compound; it is a mixture of different chemical compounds. The most important of its behavioral characteristics happens when it heats up. When you raise the temperature of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-259"
    }
  }, [_vm._v("crude oil to a temperature where it starts to boil and hold it at that ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-260"
    }
  }, [_vm._v("temperature, some of it will vaporize and some of it won’t.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-260"
    }
  }, [_vm._v("Contrast that with ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-261"
    }
  }, [_vm._v("water to make a point. Take the pot of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-262"
    }
  }, [_vm._v("water in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_1"
    }
  }, [_vm._v("Figure 3-1")]), _vm._v(" and heat it to 212"), _c('sup', [_vm._v("0")]), _vm._v("F (Fahrenheit) and keep the heat on. What happens? The "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-263"
    }
  }, [_vm._v("water starts to boil. (It vaporizes or "), _c('i', [_vm._v("flashes")]), _vm._v(".) Eventually, if you keep the heat on, all the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-264"
    }
  }, [_vm._v("water will boil off.")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig_3_1"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-264"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 3–1. Boiling Water",
      "src": "images/Fig_3-1_Boiling_water.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-264"
    }
  }, [_c('b', [_vm._v("Fig. 3–1. ")]), _vm._v("Boiling ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-265"
    }
  }, [_vm._v("Water")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-265"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("If you had a thermometer in the pot, you would notice that the temperature of the ")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-266"
    }
  }, [_vm._v("water just before the last bit boiled off would still be 212"), _c('sup', [_vm._v("0")]), _vm._v("F. That’s because the chemical compound ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-267"
    }
  }, [_vm._v("H"), _c('sub', [_vm._v("2")]), _vm._v("O boils at 212"), _c('sup', [_vm._v("0")]), _vm._v("F. At atmospheric pressure, it boils at no more, no less.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-268"
    }
  }, [_vm._v("Crude Oil Composition")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-268"
    }
  }, [_vm._v("Now back to ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-269"
    }
  }, [_vm._v("crude oil. Unlike ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-270"
    }
  }, [_vm._v("water, crude is not "), _c('i', [_vm._v("a single")]), _vm._v(" chemical compound but thousands, sometimes over hundreds of thousands of different compounds. Some are as simple as CH"), _c('sub', [_vm._v("4")]), _vm._v(" (")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-271"
    }
  }, [_vm._v("methane); some are as complex as C"), _c('sub', [_vm._v("35")]), _vm._v("H"), _c('sub', [_vm._v("50")]), _vm._v(". CH"), _c('sub', [_vm._v("4 ")]), _vm._v("and C"), _c('sub', [_vm._v("35")]), _vm._v("H"), _c('sub', [_vm._v("50 ")]), _vm._v("are the chemist’s shorthand for individual types of chemical compounds. No need to get bogged down about that right now. (You can get bogged down with it in Chapter 6.) They are all generally combinations of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-272"
    }
  }, [_vm._v("hydrogen and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-273"
    }
  }, [_vm._v("carbon atoms, called "), _c('i', [_vm._v("hydrocarbons")]), _vm._v(". Each of these "), _c('i', [_vm._v("types")]), _vm._v(" of compounds has its own ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-274"
    }
  }, [_vm._v("boiling temperature, and therein lies the rub, the most useful and used physical phenomenon in the petroleum industry.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-275"
    }
  }, [_vm._v("Distillation Curves")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-275"
    }
  }, [_vm._v("Take the same pot and fill it with a typical ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-276"
    }
  }, [_vm._v("crude oil. Put the flame under it and heat it up. As the temperature reaches 150"), _c('sup', [_vm._v("0")]), _vm._v("F, the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-277"
    }
  }, [_vm._v("crude oil will start to boil, as in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_2"
    }
  }, [_vm._v("Figure 3-2")]), _vm._v(". Now adjust the flame under the pot to maintain the temperature at 150"), _c('sup', [_vm._v("0")]), _vm._v("F. After a while, the crude stops boiling.")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig_3_2"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 3–2. Boiling Crude Oil",
      "src": "images/Fig_3-2_Boiling_Crude_Oil.jpg"
    }
  })]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Fig. 3–2.")]), _vm._v(" Boiling Crude Oil")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Step two, raise the flame and heat the crude to 450"), _c('sup', [_vm._v("0")]), _vm._v("F. Again the crude starts boiling and after a while stops.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("You could repeat the steps on and on, and more and more crude would boil off. What is happening? The molecules that individually boil below 150"), _c('sup', [_vm._v("0")]), _vm._v("F vaporized in the first step; the ones that boil at "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-278"
    }
  }, [_vm._v("temperatures between 150"), _c('sup', [_vm._v("0")]), _vm._v("F and 450"), _c('sup', [_vm._v("0")]), _vm._v("F vaporized in the second step, and so on.")])])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig_3_3"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-278"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 3–3. Crude Oil Distillation Curve",
      "src": "images/Fig_3-3_Crude_Oil_Distillation_Curve.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-278"
    }
  }, [_c('b', [_vm._v("Fig. 3–3. ")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-279"
    }
  }, [_vm._v("Crude Oil ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-280"
    }
  }, [_vm._v("Distillation Curve")])])])]), _c('div', {
    staticClass: "encsimple",
    attrs: {
      "id": "enc-002"
    }
  }, [_c('h2', {
    staticClass: "enc_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-280"
    }
  }, [_c('span', [_vm._v("Bigger and Heavier")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-280"
    }
  }, [_vm._v("Generally the more ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-281"
    }
  }, [_vm._v("carbon atoms in the compound, the higher the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-282"
    }
  }, [_vm._v("boiling temperature, as shown in these examples:")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-002"
    }
  }, [_c('figure', {
    staticClass: "stablarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-282"
    }
  }, [_c('img', {
    staticClass: "stablarge",
    attrs: {
      "alt": "Tableau",
      "src": "images/tab-001.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-282"
    }
  }, [_vm._v("It is also easy to notice the relationship between the weight of the molecules and the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-283"
    }
  }, [_vm._v("temperature at which they boil.")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-283"
    }
  }, [_vm._v("What you are developing is called a ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-284"
    }
  }, [_c('i', [_vm._v("distillation curve")]), _vm._v(", a plot of temperature on one scale and the percent evaporated on the other, as in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_3"
    }
  }, [_vm._v("Figure 3-3")]), _vm._v(". The crude from each and every oil field has a unique "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-285"
    }
  }, [_vm._v("distillation curve that helps characterize what kinds of hydrocarbons are in that crude. ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_4"
    }
  }, [_vm._v("Figure 3-4")]), _vm._v(" shows a sampling of worldwide crudes. The light crudes tend to have more "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-286"
    }
  }, [_vm._v("gasoline, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-287"
    }
  }, [_vm._v("naphtha, and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-288"
    }
  }, [_vm._v("kerosene; the heavy crudes tend to have more ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-289"
    }
  }, [_vm._v("gas oil and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-290"
    }
  }, [_vm._v("residue. Refinery management always want to know how much of each of these components are in the various crudes available to them. They will have their laboratory run an "), _c('i', [_vm._v("assay")]), _vm._v(" of the crudes. The first test "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("they run doesn’t use a pot with ")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-291"
    }
  }, [_vm._v("crude oil in it. Rather they use an apparatus like that in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_5"
    }
  }, [_vm._v("Figure 3-5")]), _vm._v(" to separate the components in "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-292"
    }
  }, [_vm._v("fractions.")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig_3_4"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-292"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 3–4. Distillation Curves of Some Crudes",
      "src": "images/Fig_3-4_Distillation_Curves_for_Various_Crudes.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-292"
    }
  }, [_c('b', [_vm._v("Fig. 3–4.")]), _vm._v(" Distillation Curves of Some Crudes")])])])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig_3_5"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-292"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 3–5. Distillation Apparatus The crude is heated slowly. As the ever warmer vapors reach the top, the temperatures are recorded. The vapors then pass through a water jacket and condense; the liquid volumes are recorded (alongside the concurrent temperatures) as they accumulate, giving a distillation curve. Courtesy Teresa Knott.",
      "src": "images/Fig_3-5_Distillation_apparatus.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-292"
    }
  }, [_c('b', [_vm._v("Fig. 3–5. ")]), _vm._v("Distillation Apparatus")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-292"
    }
  }, [_vm._v("The crude is heated slowly. As the ever warmer vapors reach the top, the temperatures are recorded. The vapors then pass through a ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-293"
    }
  }, [_vm._v("water jacket and condense; the liquid volumes are recorded (alongside the concurrent temperatures) as they accumulate, giving a ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-294"
    }
  }, [_vm._v("distillation curve. Courtesy Teresa Knott.")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-294"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  })]), _c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-294"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-295"
    }
  }, [_vm._v("Fractions")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-295"
    }
  }, [_vm._v("To further specify the character of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-296"
    }
  }, [_vm._v("crude oil, refiners have found it useful to lump certain compounds into groups called ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-297"
    }
  }, [_c('i', [_vm._v("fractions")]), _vm._v(". ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-298"
    }
  }, [_vm._v("Fractions or "), _c('i', [_vm._v("cuts")]), _vm._v(" are the generic names for all the compounds that boil between two given temperatures, called ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-299"
    }
  }, [_c('i', [_vm._v("cut points")]), _vm._v(". Commonly used cutpoints to describe the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-300"
    }
  }, [_vm._v("fractions in ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-301"
    }
  }, [_vm._v("crude oil are:")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-001"
    }
  }, [_c('figure', {
    staticClass: "stablarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-301"
    }
  }, [_c('img', {
    staticClass: "stablarge",
    attrs: {
      "alt": "Tableau",
      "src": "images/tab-002.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-301"
    }
  }, [_vm._v("Later chapters will spend a lot of words discussing the characteristic of each of those ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-302"
    }
  }, [_vm._v("fractions, but some are already apparent from their names. ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_6"
    }
  }, [_vm._v("Figure 3-6")]), _vm._v(" shows where the various cuts plot on a typical "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-303"
    }
  }, [_vm._v("distillation curve.")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig_3_6"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-303"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 3–6. Fractions (or Cuts) from Crude Oil",
      "src": "images/Fig_3-6_Fractions_or_Cuts_from_Crude_Oil.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-303"
    }
  }, [_c('b', [_vm._v("Fig. 3–6.")]), _vm._v(" Fractions (or Cuts) from Crude Oil")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-303"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Cutting Crudes")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-303"
    }
  }, [_vm._v("To pull together all this information on ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-304"
    }
  }, [_vm._v("distillation curves, follow this quick arithmetic manipulation. Take the curves for the two crudes in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_7"
    }
  }, [_vm._v("Figure 3-7")]), _vm._v(" and run through the steps to determine which crude has higher "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-305"
    }
  }, [_vm._v("kerosene content (a bigger ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-306"
    }
  }, [_vm._v("kerosene cut.)")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-307"
    }
  }, [_vm._v("Kerosene has a ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-308"
    }
  }, [_vm._v("boiling temperature range from about 315"), _c('sup', [_vm._v("0")]), _vm._v("F to 450"), _c('sup', [_vm._v("0")]), _vm._v("F. Using ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_5"
    }
  }, [_vm._v("Figure 3-5")]), _vm._v(", complete the following steps:")]), _c('ol', {
    staticClass: "liste_num_point"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" For the heavy crude (the curve that starts off higher because it has very little light stuff in it), start from the vertical axis at 315"), _c('sup', [_vm._v("0")]), _vm._v("F and intersect the "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-309"
    }
  }, [_vm._v("distillation curve, going right to point A. Going down from point A hits 26 percent on the horizontal axis. That’s the amount that will have boiled off before any ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-310"
    }
  }, [_vm._v("kerosene boils off.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-310"
    }
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" Now start at 450"), _c('sup', [_vm._v("0")]), _vm._v("F and intersect the same ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-311"
    }
  }, [_vm._v("distillation curve, going right, at point B, which is 42 percent on the horizontal axis. That’s the amount that has boiled off when ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-312"
    }
  }, [_vm._v("kerosene stops boiling off.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-312"
    }
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("3")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("Calculate the cumulative percent volume from the "), _c('i', [_vm._v("initial ")])])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-313"
    }
  }, [_c('i', [_vm._v("boiling point")]), _vm._v(" of the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-314"
    }
  }, [_vm._v("kerosene to the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-315"
    }
  }, [_c('i', [_vm._v("end point")]), _vm._v(": 42 – 26 = 16 percent. The heavy crude contains 16 percent ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-316"
    }
  }, [_vm._v("kerosene.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-316"
    }
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("4")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" Now do the same procedure for the light crude and find that there is 66.5 – 48.5 = 18 percent.")])])])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig_3_7"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-316"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 3–7. Kerosene Cut from Two Different Crudes",
      "src": "images/Fig_3-7_Kerosene_Cut_from_Two_Different_Crudes.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-316"
    }
  }, [_c('b', [_vm._v("Fig. 3–7.")]), _vm._v(" Kerosene Cut from Two Different Crudes")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-316"
    }
  }, [_vm._v("Therefore, the light crude has more ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-317"
    }
  }, [_vm._v("kerosene in it than the heavy crude. If some refiners were in the business of trying to produce as much ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-318"
    }
  }, [_vm._v("kerosene as possible—and they sometimes are—they might prefer to buy the lighter crude to the heavier, despite a dozen or more other considerations.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-011"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-319"
    }
  }, [_vm._v("Gravities")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-320"
    }
  }, [_vm._v("Gravities measure the relative weight of a compound, another important characteristic. Chemists always use a measure called ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-321"
    }
  }, [_c('i', [_vm._v("specific gravity,")]), _vm._v(" which relates everything to something universally familiar, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-322"
    }
  }, [_vm._v("water.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-322"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("The ")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-323"
    }
  }, [_vm._v("specific gravity of any liquid is equal to the weight of some volume of that compound divided by the weight of the same volume of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-324"
    }
  }, [_vm._v("water, all at standard pressures and temperatures.")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-017"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-324"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/Formule_1.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-324"
    }
  }, [_vm._v("The chemists’ approach must have been too simple for the petroleum engineers because the popular measure of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-325"
    }
  }, [_vm._v("gravity in the oil industry is a diabolical measure called ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-326"
    }
  }, [_c('i', [_vm._v("API gravity")]), _vm._v(". The formula for ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-327"
    }
  }, [_vm._v("API gravity, which is measured in degrees (but has nothing to do with temperature or angles), is")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-018"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-327"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/Formule_2.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-327"
    }
  }, [_vm._v("The origin of the 141.5 and 131.5 appears to be lost in the mists of history. Nevertheless, if you play with the formula a little bit, you’ll find the following relationships, which might be the mental hooks on which you can hang the concepts:")])]), _c('ol', {
    staticClass: "liste_num_point"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-327"
    }
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-328"
    }
  }, [_vm._v("Water has a ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-329"
    }
  }, [_vm._v("specific gravity of 1 and an ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-330"
    }
  }, [_vm._v("API gravity of 10"), _c('sup', [_vm._v("0")])])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-330"
    }
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" Counterintuitively, the higher the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-331"
    }
  }, [_vm._v("API gravity, the lighter the compound, as shown in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_8"
    }
  }, [_vm._v("Figure 3-8")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("3")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" The reverse is true for "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-332"
    }
  }, [_vm._v("specific gravity")])])])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig_3_8"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-332"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 3–8. API Gravities of Asphalt and Gasoline The higher the degree API, the lower the weight.",
      "src": "images/Fig_3-8_API_Gravities_of_Asphalt_and_Naphtha.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-332"
    }
  }, [_c('b', [_vm._v("Fig. 3–8. ")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-333"
    }
  }, [_vm._v("API Gravities of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-334"
    }
  }, [_vm._v("Asphalt and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-335"
    }
  }, [_vm._v("Gasoline")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-335"
    }
  }, [_vm._v("The higher the degree API, the lower the weight.")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-335"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("Typical ")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-336"
    }
  }, [_vm._v("gravities:")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-002"
    }
  }, [_c('figure', {
    staticClass: "stablarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-336"
    }
  }, [_c('img', {
    staticClass: "stablarge",
    attrs: {
      "alt": "Tableau",
      "src": "images/tab-003.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-336"
    }
  }, [_vm._v("Common knowledge says oil floats on ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-337"
    }
  }, [_vm._v("water. The sheen you might have seen from a boat motor or a dock ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-338"
    }
  }, [_vm._v("gasoline pump results from oil not dissolving in ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-339"
    }
  }, [_vm._v("water and being at an ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-340"
    }
  }, [_vm._v("API gravity above 10"), _c('sup', [_vm._v("0")]), _vm._v(". Not all oil weighs that little. Industry lore (as documented by your author) has stories of barge operators who assumed that all oils are lighter than ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-341"
    }
  }, [_vm._v("water. To their horror as they filled their barge with ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-342"
    }
  }, [_vm._v("asphalt, it sank before their eyes. After the fact, they learned they were loading 9"), _c('sup', [_vm._v("0")]), _vm._v(" API material.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-342"
    }
  }, [_vm._v("Tonnes, Barrels, and Gallons")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-342"
    }
  }, [_vm._v("A volumetric convention grew out of the Pennsylvania oil fields, according to oil patch lore. Oil was initially shipped to market by horse-drawn wagon or flatcar in used 46, 48, and 50 gallon wine, pickle, apple, biscuit, nail, and other types of barrels. Refiners insisted on allowing for spillage and leakage after producers hauled it over poorly constructed roads from the oil fields to the refineries. They paid producers on the basis of 42 gallons, which became the “oil barrel.”")])]), _c('div', {
    staticClass: "encsimple",
    attrs: {
      "id": "enc-003"
    }
  }, [_c('h2', {
    staticClass: "enc_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-342"
    }
  }, [_c('span', [_vm._v("Displacement")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-342"
    }
  }, [_vm._v("King Henry VIII found out the mechanics of displacement when he overloaded his flagship, the Mary Rose, with cannon and troops, and watched with horror as it sank off Portsmouth Harbor as it set off to battle the French in 1545.")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-342"
    }
  }, [_vm._v("Transportation in the United States was primarily by wagon, train, and eventually truck and pipeline. Measuring by volume made sense. In most of the rest of the world, the industry moved oil by seagoing vessels. That required calculating the weight of the cargo to assure the load would not exceed the displacement of the ship. In Europe and Asia, weight, usually measured in "), _c('i', [_vm._v("tonnes ")]), _vm._v("(2,240 U.S. pounds) became the maritime standard by which oil was bought, sold, and transported. Curiously enough, despite all this, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-343"
    }
  }, [_vm._v("gasoline at the retail pump has always been sold everywhere by volume, in gallons or liters, more because of the metering devices than anything else.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-013"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-343"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  })]), _c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-343"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-344"
    }
  }, [_vm._v("Sulfur Content")])]), _c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-004"
    }
  }, [_c('h2', {
    staticClass: "enc_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-344"
    }
  }, [_c('span')]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-345"
    }
  }, [_vm._v("Sulfur or Sulphur?")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-345"
    }
  }, [_vm._v("Americans generally spell ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-346"
    }
  }, [_vm._v("sulfur with an "), _c('i', [_vm._v("f")]), _vm._v(", while British use a "), _c('i', [_vm._v("ph")]), _vm._v(". Both are acceptable, but Yanks, eschewing the more phonetic form, are unaccountably more etymologically frugal in this regard.")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-346"
    }
  }, [_vm._v("One more excursion on the subject of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-347"
    }
  }, [_vm._v("crude oil is appropriate at this point—a discussion of the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-348"
    }
  }, [_vm._v("sulfur content in ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-349"
    }
  }, [_vm._v("crude oil. One of the annoying aspects nature endowed on ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-350"
    }
  }, [_vm._v("crude oils is the differing amounts of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-351"
    }
  }, [_vm._v("sulfur content in various types of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-352"
    }
  }, [_vm._v("crude oil. To complicate this bequest, the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-353"
    }
  }, [_vm._v("sulfur is not in the form of little yellow bits of elemental ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-354"
    }
  }, [_vm._v("sulfur, a chemical all by itself, but is almost always a ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-355"
    }
  }, [_vm._v("sulfur compound. In some cases, the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-356"
    }
  }, [_vm._v("sulfur could be in the form of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-357"
    }
  }, [_vm._v("hydrogen sulfide, H"), _c('sub', [_vm._v("2")]), _vm._v("S, a toxic gas, or a mercaptan, another smelly ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-358"
    }
  }, [_vm._v("sulfur compound. Both these require special treatment for removal. More pervasively, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-359"
    }
  }, [_vm._v("sulfur may be chemically bonded to some of the more complicated oil molecules so that it is not easily separated from the pure ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-360"
    }
  }, [_vm._v("carbon compounds. That is, not until it is burned. Then it will form one of several smelly or otherwise environmentally objectionable ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-361"
    }
  }, [_vm._v("sulfur/")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-362"
    }
  }, [_vm._v("oxygen compounds. So ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-363"
    }
  }, [_vm._v("sulfur removal before hydrocarbons ever get to the burner tip remains a big issue for refiners today and will be the subject of many words later on in Chapter 16.")])]), _c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-005"
    }
  }, [_c('h2', {
    staticClass: "enc_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-363"
    }
  }, [_c('span')]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-364"
    }
  }, [_vm._v("Sweets and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-365"
    }
  }, [_vm._v("Sours")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-365"
    }
  }, [_vm._v("Typical ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-366"
    }
  }, [_vm._v("sweet crudes include West Texas Intermediate, the popular traded crude on the New York Mercantile Exchange, many Lousiana and Oklahoma, and Nigerian crudes, and Brent North Sea, the crude traded on the International Petroleum Exchange.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-367"
    }
  }, [_vm._v("Sour crudes include Alaska North Slope, Venezuelan, and West Texas Sour from fields like Yates and Wasson.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-367"
    }
  }, [_vm._v("Intermediate crudes include California Heavy, such as from the San Joaquin Valley, and many Middle East crudes.")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-367"
    }
  }, [_vm._v("The parlance in discussing ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-368"
    }
  }, [_vm._v("crude oils of varying ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-369"
    }
  }, [_vm._v("sulfur content is to categorize them into ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-370"
    }
  }, [_c('i', [_vm._v("sweet")]), _vm._v(" crudes and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-371"
    }
  }, [_c('i', [_vm._v("sour")]), _vm._v(" crudes. This quaint, faintly oriental designation of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-372"
    }
  }, [_vm._v("sweet and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-373"
    }
  }, [_vm._v("sour has more to do with taste than you might think. In the early days of Pennsylvania ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-374"
    }
  }, [_vm._v("crude oil production, petroleum was primarily sought after to make ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-375"
    }
  }, [_vm._v("kerosene as a substitute for the whale oil used as lamp oil for indoor lighting. If a ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-376"
    }
  }, [_vm._v("kerosene ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-377"
    }
  }, [_vm._v("fraction had too much ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-378"
    }
  }, [_vm._v("sulfur, it would have an unacceptable smell when it burned. In addition, the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-379"
    }
  }, [_vm._v("sulfur would accelerate the rate at which silver would tarnish—clearly a bad thing to have in a home. Early on, an unknown soul discovered that ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-380"
    }
  }, [_vm._v("kerosene with higher ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-381"
    }
  }, [_vm._v("sulfur content had a more sour taste and that with a low ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-382"
    }
  }, [_vm._v("sulfur content had a more ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-383"
    }
  }, [_vm._v("sweet taste. Over a time long enough for the designation to become permanent, tasting was the generally acceptable method for determining which crudes would make good lamp oil. (The silver tarnishing resulted from burning ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-384"
    }
  }, [_vm._v("sulfur-containing oil, forming byproduct ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-385"
    }
  }, [_vm._v("sulfur oxides that chemically attacked the silver, creating silver sulfate, another name for tarnish.)")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-385"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("Today, ")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-386"
    }
  }, [_vm._v("sweet crudes typically have 0.5 percent ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-387"
    }
  }, [_vm._v("sulfur content or less, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-388"
    }
  }, [_vm._v("sour 1.5 percent or more. The area in between is sometimes called "), _c('i', [_vm._v("intermediate ")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-389"
    }
  }, [_c('i', [_vm._v("sweet")]), _vm._v(" or "), _c('i', [_vm._v("intermediate sour")]), _vm._v(", but the distinction is not clear. What may be ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-390"
    }
  }, [_vm._v("sweet to some may be sour")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-391"
    }
  }, [_vm._v(" to others, now that all the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-392"
    }
  }, [_vm._v("crude oil tasters are up in the gourmet cloud in the sky.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-014"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-393"
    }
  }, [_vm._v("Metals, Acids, and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-394"
    }
  }, [_vm._v("Wax")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-395"
    }
  }, [_vm._v("Carbon and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-396"
    }
  }, [_vm._v("hydrogen from the organic material buried deep in the earth were not the only elements around. Others snuck into the hydrocarbon molecules as they cooked over time. Like crudes with high ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-397"
    }
  }, [_vm._v("sulfur content, crudes with high heavy ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-398"
    }
  }, [_vm._v("metals and high acid content are always discounted against their counterpart “clean” crudes.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-001"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-399"
    }
  }, [_vm._v("Metals")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-399"
    }
  }, [_vm._v("Different ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-400"
    }
  }, [_vm._v("metals resided in the source rocks where the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-401"
    }
  }, [_vm._v("crude oil formed—vanadium, nickel, copper, lead, iron, magnesium, sodium, molybdenum, zinc, cadmium, titanium, manganese, chromium, cobalt, antimony, uranium, aluminum, tin, barium, gallium, silver, and arsenic. After all, it’s dirt. Many ended up hooking up with the hydrocarbons in miniscule amounts. Some, even small amounts, endanger full exploitation of the oil as it passes through the refining system. Nickel and vanadium, for example, will poison ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-402"
    }
  }, [_vm._v("cat cracking ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-403"
    }
  }, [_vm._v("catalyst, making frequent replacement necessary.")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig_3_9"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-403"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 3–9. Bubble Cap Pitted by High TAN Crude",
      "src": "images/Fig_3-9_Distilling_Unit_Bubble_Cap_Pitted_by_High_Tan_Crude.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-403"
    }
  }, [_c('b', [_vm._v("Fig. 3–9. ")]), _vm._v("Bubble Cap Pitted by High TAN Crude")])])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-002"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-403"
    }
  }, [_vm._v("Acids")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-403"
    }
  }, [_vm._v("As crudes form, instead of a plain old hydrocarbon, some ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-404"
    }
  }, [_vm._v("carbon, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-405"
    }
  }, [_vm._v("hydrogen, and any ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-406"
    }
  }, [_vm._v("oxygen atoms can form a carboxylic acid, whose formula is R-COOH. The R stands for a hydrocarbon molecule that the carboxyl group, -COOH has hooked up with. Hydrocarbons with ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-407"
    }
  }, [_vm._v("naphthenes in their structure are more susceptible to attracting carboxylic groups, and naphthenic crudes tend to have more (naphthenic) acids in them.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-407"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-408"
    }
  }, [_vm._v("Crude oil assays list the results of a test for acid content—Total Acid Number, or TAN. The test involves measuring the small amount of potassium hydroxide, a base, necessary to neutralize any acid in a same small amount of the crude. Modern refinery laboratories may use spectrometry to determine the TAN. Table 3-1 has the TANs of some international crudes.")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-003"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-030"
    }
  }, [_c('b', [_vm._v("Table 3-1. ")]), _vm._v("TANs of Various Crudes")])])]), _c('figure', {
    staticClass: "stablarge"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-030"
    }
  }, [_c('img', {
    staticClass: "stablarge",
    attrs: {
      "alt": "Tableau. Table 3-1. TANs of Various Crudes",
      "src": "images/tab-004.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-030"
    }
  }, [_vm._v("The presence of acids can lead to destructive corrosion of pipelines, tankage, and particularly refinery operating units where high temperatures enhance chemical interaction. (See ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_9"
    }
  }, [_vm._v("Figure 3-9")]), _vm._v(", a device that will be dealt with in Chapter 4.) Refineries processing high TAN number crudes may have to treat the "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-409"
    }
  }, [_vm._v("crude oil or its heavier ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-410"
    }
  }, [_vm._v("fractions with ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-411"
    }
  }, [_vm._v("hydrogen to reduce the –COOH group to ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-412"
    }
  }, [_vm._v("H"), _c('sub', [_vm._v("2")]), _vm._v("O and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-413"
    }
  }, [_vm._v("CO"), _c('sub', [_vm._v("2")]), _vm._v(". A TAN of 0.017 would not be an issue for a refinery but one with a 3.6 TAN would be worrisome.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-003"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-414"
    }
  }, [_vm._v("Wax")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-414"
    }
  }, [_vm._v("Long chain ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-415"
    }
  }, [_vm._v("paraffins, those with thirty or more ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-416"
    }
  }, [_vm._v("carbons and especially those with lots of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-417"
    }
  }, [_vm._v("branches, solidify at ambient temperatures. Some crudes are rich in these ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-418"
    }
  }, [_vm._v("paraffins and as a result present special problems in transportation; they have to be moved in heated pipelines, trucks, or tank cars to avoid becoming a solid, immovable mass, especially in cold weather.")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-015"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-418"
    }
  }, [_vm._v("Review")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_4"
    }
  }, [_vm._v("Figure 3-4")]), _vm._v(" shows the "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-419"
    }
  }, [_vm._v("distillation curves for six different crudes, three U.S. and three non-U.S. Some have more light ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-420"
    }
  }, [_vm._v("fractions, some have more heavy. All have different prices, so refiners will have different incentives to process them as each emphasizes different cuts.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-016"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-420"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Exercises")])])]), _c('ol', {
    staticClass: "liste_num_point"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-420"
    }
  }), _c('li', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-420"
    }
  }), _c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-420"
    }
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" Draw the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-421"
    }
  }, [_vm._v("distillation curve for the following ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-422"
    }
  }, [_vm._v("crude oils (on the same graph).")])])])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-004"
    }
  }, [_c('figure', {
    staticClass: "stablarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-422"
    }
  }, [_c('img', {
    staticClass: "stablarge",
    attrs: {
      "alt": "Tableau",
      "src": "images/tab-005.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-422"
    }
  }, [_vm._v("How much ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-423"
    }
  }, [_vm._v("naphtha (220 – 315"), _c('sup', [_vm._v("0")]), _vm._v("F) is there in each crude?")])]), _c('ol', {
    staticClass: "liste_num_point"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-423"
    }
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" Suppose you had a beaker of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-424"
    }
  }, [_vm._v("asphalt (11"), _c('sup', [_vm._v("0")]), _vm._v("API) and a beaker of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-425"
    }
  }, [_vm._v("naphtha (50"), _c('sup', [_vm._v("0")]), _vm._v("API), both equal volumes. If you mixed them together, what would be the resulting ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-426"
    }
  }, [_vm._v("API gravity? The answer is "), _c('span', {
    staticClass: "sl"
  }, [_vm._v("not")]), _vm._v(" 30.5"), _c('sup', [_vm._v("0")]), _vm._v(" API.")])])])])])])])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-426"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d40e346","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap3.vue
// module id = 81
// module chunks = 0